import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
}

export default function GriffinStatus(props: Props) {
    const [snAvailL1, setAvailL1] = useState(false);
    const [snCalL1, setCalL1] = useState(false);
    const [snJammerL1, setJammerL1] = useState(false);
    const [snSpooferL1, setSpooferL1] = useState(false);
    const [snAvailL2, setAvailL2] = useState(false);
    const [snCalL2, setCalL2] = useState(false);
    const [snJammerL2, setJammerL2] = useState(false);
    const [snSpooferL2, setSpooferL2] = useState(false);
    const [snCalQualityL1, setCalQualityL1] = useState(0.0);
    const [snCalThresholdL1, setCalThresholdL1] = useState(0.0);
    const [snCalQualityL2, setCalQualityL2] = useState(0.0);
    const [snCalThresholdL2, setCalThresholdL2] = useState(0.0);

    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            var availL1 = false;
            var calL1 = false;
            var jammerL1 = false;
            var spooferL1 = false;
            var availL2 = false;
            var calL2 = false;
            var jammerL2 = false;
            var spooferL2 = false;
            var calQualityL1 = 0.0;
            var calThresholdL1 = 0.0;
            var calQualityL2 = 0.0;
            var calThresholdL2 = 0.0;
            if(SNStatus[props.index].Status.Array.length > 0) {
                availL1 = SNStatus[props.index].Status.Array[0].Avail;
                calL1 = SNStatus[props.index].Status.Array[0].Cal;
                jammerL1 = SNStatus[props.index].Status.Array[0].Jammer;
                spooferL1 = SNStatus[props.index].Status.Array[0].Spoofer;
                calQualityL1 = SNStatus[props.index].Calibration.Array[0].Quality;
                calThresholdL1 = SNStatus[props.index].Calibration.Array[0].Threshold;
            }
            if(SNStatus[props.index].Status.Array.length > 1) {
                availL2 = SNStatus[props.index].Status.Array[1].Avail;
                calL2 = SNStatus[props.index].Status.Array[1].Cal;
                jammerL2 = SNStatus[props.index].Status.Array[1].Jammer;
                spooferL2 = SNStatus[props.index].Status.Array[1].Spoofer;
                calQualityL2 = SNStatus[props.index].Calibration.Array[1].Quality;
                calThresholdL2 = SNStatus[props.index].Calibration.Array[1].Threshold;
            }
            setAvailL1(availL1);
            setCalL1(calL1);
            setJammerL1(jammerL1);
            setSpooferL1(spooferL1);
            setAvailL2(availL2);
            setCalL2(calL2);
            setJammerL2(jammerL2);
            setSpooferL2(spooferL2);
            setCalQualityL1(calQualityL1);
            setCalThresholdL1(calThresholdL1);
            setCalQualityL2(calQualityL2);
            setCalThresholdL2(calThresholdL2);
        } else {
            setAvailL1(false);
            setCalL1(false);
            setJammerL1(false);
            setSpooferL1(false);
            setAvailL2(false);
            setCalL2(false);
            setJammerL2(false);
            setSpooferL2(false);
            setCalQualityL1(0.0);
            setCalThresholdL1(0.0);
            setCalQualityL2(0.0);
            setCalThresholdL2(0.0);
        }
    }, [SNTime, props.index]);
    
    return (
	<div>
            <Table><TableBody>
                <TableRow className='name_row' style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', maxWidth: '90%', margin: '0 auto', backgroundColor: 'black', height: '10%'}}>
                    <TableCell colSpan={1} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '20%', margin: '5px', backgroundColor: 'black'}} padding='none'>
                        { snAvailL1 && snJammerL1 && snSpooferL1 && <button className="bnt_orange_flash">L1 Jammer/Spoofer</button> }
                        { snAvailL1 && snJammerL1 && (!snSpooferL1) && <button className="bnt_orange_flash">L1 Jammer</button> }
                        { snAvailL1 && (!snJammerL1) && snSpooferL1 && <button className="bnt_orange_flash">L1 Spoofer</button> }
                        { snAvailL1 && (!snJammerL1) && (!snSpooferL1) && <button className="bnt_green">L1 No Detection</button> }
                        { (!snAvailL1) && <button className="bnt_grey">L1 No Detection</button> }
                    </TableCell>
                    <TableCell colSpan={1} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '20%', margin: '5px', backgroundColor: 'black'}} padding='none'>
                        { snAvailL2 && snJammerL2 && snSpooferL2 && <button className="bnt_orange_flash">L2 Jammer/Spoofer</button> }
                        { snAvailL2 && snJammerL2 && (!snSpooferL2) && <button className="bnt_orange_flash">L2 Jammer</button> }
                        { snAvailL2 && (!snJammerL2) && snSpooferL2 && <button className="bnt_orange_flash">L2 Spoofer</button> }
                        { snAvailL2 && (!snJammerL2) && (!snSpooferL2) && <button className="bnt_green">L2 No Detection</button> }
                        { (!snAvailL2) && <button className="bnt_grey">L2 No Detection</button> }
                    </TableCell>
		</TableRow>
		<TableRow className='name_row' style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', maxWidth: '90%', margin: '0 auto', backgroundColor: 'black', height: '10%'}}>
                    <TableCell colSpan={1} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '20%', margin: '5px', backgroundColor: 'black'}} padding='none'>
                        { snAvailL1 && snCalL1 && <button className="bnt_green">{'L1 Cal ' + snCalQualityL1}</button> }
                        { snAvailL1 && (!snCalL1) && <button className="bnt_orange_flash">{'L1 Cal ' + snCalQualityL1}</button> }
                        { (!snAvailL1) && <button className="bnt_grey">{'L1 Cal ' + snCalQualityL1}</button> }
                    </TableCell>
                    <TableCell colSpan={1} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '20%', margin: '5px', backgroundColor: 'black'}} padding='none'>
                        { snAvailL2 && snCalL2 && <button className="bnt_green">{'L2 Cal ' + snCalQualityL2}</button> }
                        { snAvailL2 && (!snCalL2) && <button className="bnt_orange_flash">{'L2 Cal ' + snCalQualityL2}</button> }
                        { (!snAvailL2) && <button className="bnt_grey">{'L2 Cal ' + snCalQualityL2}</button> }
                    </TableCell>
                </TableRow>
            </TableBody></Table>
        </div>
    )
}
